import { render, staticRenderFns } from "./NotifyModal.vue?vue&type=template&id=1a15128a&scoped=true&"
import script from "./NotifyModal.vue?vue&type=script&lang=js&"
export * from "./NotifyModal.vue?vue&type=script&lang=js&"
import style0 from "./NotifyModal.vue?vue&type=style&index=0&id=1a15128a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a15128a",
  null
  
)

export default component.exports